<template>
  <InputDefault preIcon="CalendarIcon"
    class="py-3 ps-10 pe-4 block w-full border-gray-400 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-900 dark:border-neutral-700 dark:text-neutral-400 dark:placeholder-neutral-500 dark:focus:ring-neutral-600"
    :clear="clear" :clearEvent="clearEvent" v-bind="$attrs" v-model="model" @click="openCalendarClick()" type="text" />
  <div :id="'calendar_content_' + $attrs.id"
    class="absolute hidden w-80 md:w-[40.4rem] flex flex-col bg-white border shadow-lg rounded-xl overflow-hidden dark:bg-neutral-900 dark:border-neutral-700">
    <div class="p-3 grid md:flex gap-8">
      <CalendarMiniDefault :closeOnSelect="false" :id="$attrs.id + '_DESDE'" v-model="desde" :time="false"
        range="desde" />
      <CalendarMiniDefault :closeOnSelect="false" :id="$attrs.id + '_HASTA'" v-model="hasta" :time="false"
        range="hasta" />
    </div>
    <div class="flex justify-end items-center gap-x-2 p-3 border-t dark:border-neutral-700">
      <span class="md:me-3 text-xs text-gray-500 dark:text-neutral-500">
        {{ desde }} / {{ hasta }}
      </span>
      <button type="button" @click="closeCalendarClick"
        class="py-2 px-3 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-gray-400 bg-white text-gray-800 shadow-sm hover:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-900 dark:border-neutral-700 dark:text-white dark:hover:bg-neutral-800">
        Cerrar
      </button>
      <button type="button" @click="setValor"
        class="py-2 px-3 inline-flex items-center gap-x-2 text-sm font-semibold rounded-lg border border-transparent bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50 disabled:pointer-events-none">
        Aplicar
      </button>
    </div>
  </div>
  <!-- End Datepicker -->
</template>
<script setup lang="ts">
import { useAttrs, ref } from 'vue'
import CalendarMiniDefault from './CalendarMiniDefault.vue'
import type { ModelValueArrayString } from '@/modules/Core/usings/constantes'
const attrs = useAttrs()
const model = defineModel<ModelValueArrayString>()

const props = defineProps({
  clear: {
    type: Boolean,
    default: false
  },
  clearEvent: Function
})
const rango = model.value && model.value.length > 1 ? model.value : [new Date().yyyymmdd(), new Date(new Date().getFullYear(), (new Date().getMonth()) + 1, 1).yyyymmdd()]
const desde = ref(rango[0])
const hasta = ref(rango[1])

function openCalendarClick() {
  const el = document.getElementById('calendar_content_' + attrs.id)
  el && el.classList.remove("hidden")
}
function closeCalendarClick() {
  const el = document.getElementById('calendar_content_' + attrs.id)
  el && el.classList.add("hidden")
}
function setValor() {
  model.value = [desde.value, hasta.value]
  closeCalendarClick()
}
</script>
